export default __webpack_public_path__ + "static/media/tv_controller.956a1cca.png";